module.exports = __webpack_public_path__ + "static/media/profile-circle.9565eb75.png";